import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

export default function DailyPerformanceCard() {
  const data = {
    labels: ["M", "T", "W", "T", "F", "S", "S"],
    datasets: [
      {
        label: "Sales",
        data: [30, 80, 50, 70, 40, 100, 60],
        backgroundColor: "#FBD150",
        borderRadius: 6,
        maxBarThickness: 50,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100, // set max to create 7 divisions
        ticks: {
          display: false,
          stepSize: 100 / 7, // 7 horizontal divisions
        },
        grid: {
          drawTicks: false,
          color: "#1D2530",
          borderDash: [2, 4],
          tickLength: 0,
        },
      },
      x: {
        grid: {
          drawTicks: false,
          color: "#1D2530",
          borderDash: [2, 4],
          tickLength: 0,
        },
        ticks: {
          stepSize: 1, // 7 vertical divisions align with labels
        },
      },
    },
  };

  return (
    <div className="bg-gradient-to-tr from-[#0F131A] to-[#171D26] shadow-[0_1px_2px_#0F131A] border border-[#1D2530] rounded-xl p-6 w-full mx-auto">
      {/* Header */}
      <div className="mb-4">
        <h3 className="text-[#F9FAFB] font-bold text-lg">Direct Sales</h3>
        <p className="text-[#9DA6AF] text-sm mt-1">Daily performance</p>
      </div>

      {/* Bar Chart */}
      <div className="relative w-full h-64">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
}
